/**
 * Sticky topbar that hosts the wordmark + picker trigger pill.
 * The pill is rendered by the Picker module so the topbar stays
 * agnostic about picker state.
 */

import type { ReactNode } from 'react';

interface TopbarProps {
  children: ReactNode;
}

export function Topbar({ children }: TopbarProps): JSX.Element {
  return (
    <div className="nl-topbar">
      <div className="nl-topbar-left">NYX</div>
      {children}
    </div>
  );
}
